import { render, staticRenderFns } from "./tipo-produto.vue?vue&type=template&id=c064b916&"
import script from "./tipo-produto.vue?vue&type=script&lang=js&"
export * from "./tipo-produto.vue?vue&type=script&lang=js&"
import style0 from "./tipo-produto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports